import React, { Component } from "react";

class Search extends Component {
  render() {
    return (
      <div>
        <div className="search-container">
          <input
            type="text"
            className="form-control"
            placeholder="Search.."
            value={this.props.searchTerm}
            onChange={this.props.handleSearchTermChange.bind(this)}
          />
          {/* <button type="button">
            <i className="fa fa-search" />
          </button> */}
        </div>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/Search.js